export const provisioningSteps = [
    {
        label: 'East Domain setup',
        description: `Domain Setup East`,
    },

    {
        label: 'Analytics',
        description: `Domain Setup West`,
    },
];

export const validateEastWest = (eastWestDomain, activeStep) => {
    const value = eastWestDomain[`domain_${activeStep}`]?.toLowerCase();

    if (activeStep === 0) {
        if (!value.includes("east")) {
            return false;
        }
    }

    if (activeStep === 1) {
        if (!value.includes("west")) {
            return false;
        }
    }

    return true;
};
export const statusColors={
    'completed':'green',
    'failed':'red',
    'inprogress':'orange',
    'disabled':'gray',
    'pending':'gray'

}

export const autoProvisioningSteps = [
    {
        label: 'Grant Consent to Enterprise Application',
        description: `Basic Information.`,
        status:'completed'
    },

    {
        label: 'Connect To Microsoft Teams',
        description: `Connect To Microsoft Teams.`,
        status:'failed'

    },
    {
        label: 'Create a1b2c.teams-east.altigen.com child domain',
        description: `Domain Creation.`,
        status:'inprogress'

    },
    {
        label: 'Invite your team',
        description: `Start collaborating with your team.`,
        status:'disabled'

    },
    {
        label: 'Add your socials',
        description: `Share post to your social accounts.`,
        status:'disabled'

    },
];